
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as NewAiChatIconComponent } from "./new-ai-chat-icon.svg";

export const NewAiChatIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <NewAiChatIconComponent {...props} />;
};
